import { inject, Injectable } from '@angular/core';
import { GoogleAnalyticsService } from './google-analytics.service';
import { AnalyticsEventName } from '../models/analytics-event-name.enum';

@Injectable({ providedIn: 'root' })
export class AnalyticsInitializerService {
  private readonly analyticsService: GoogleAnalyticsService = inject(GoogleAnalyticsService);
  private screenResolutionTracked = false;

  public init(): void {
    this.analyticsService.loadScriptIfEnabled();

    if (this.screenResolutionTracked) {
      return;
    }

    this.analyticsService.trackEvent(AnalyticsEventName.ScreenResolution, {
      width: window.screen.width,
      height: window.screen.height
    });
    this.screenResolutionTracked = true;
  }
}
